import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M77.2 43.0283C77.2 43.0283 59.37 33.7183 55.32 28.9783C50.82 23.7183 51.02 1.07837 51.02 1.07837H38.6C38.6 1.07837 38.91 23.8283 34.3 28.9783C29.41 34.4383 12.25 42.6884 12.25 42.6884C18.44 57.2684 35.27 58.6884 44.81 58.6884C54.35 58.6884 71.01 57.6083 77.2 43.0283Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M86.3804 58.3483C84.8104 48.1483 81.8004 44.6683 77.7704 42.4683C77.3604 42.2383 73.1404 40.0883 72.7004 39.8783L63.0504 49.7084H26.3904L16.0604 40.4584C15.5804 40.6884 11.9904 42.2983 11.5404 42.5583C7.58039 44.8183 4.60039 48.5783 3.07039 58.3583C1.41039 68.9583 1.15039 71.2883 1.15039 71.2883H88.3004C88.3004 71.2783 88.0104 68.8983 86.3804 58.3483Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.5208 53.4683L24.0908 54.3783"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M23.2504 56.1383L16.9404 69.4083"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeDasharray="1.96 1.96"
      />
      <path
        d="M16.5208 70.2883L16.0908 71.1984"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M64.4502 53.4384L64.8902 54.3383"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M65.7402 56.0983L72.1002 69.2283"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeDasharray="1.95 1.95"
      />
      <path
        d="M72.5303 70.0983L72.9603 70.9983"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.5205 42.3483L24.4905 53.4384H64.4505L75.8505 42.1884"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="44.727"
          y1="25.4715"
          x2="44.727"
          y2="8.74037"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
